import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography, IconButton, makeStyles } from "@material-ui/core";
import { upsellToPaid } from "../../../../utilities/Upsell";
import { useAuthenticatedUser } from "../../../../utilities/useAuthenticatedUser";
import { useIsMobile } from "../../../../components/Mui3WidthProvider";
import { SermonTemplate } from "../../../../entities/SermonTemplate";
import { AddAssetAction } from "../../../../entities/AddAssetAction";

const useStyles = makeStyles(() => ({
	userTemplateButton: {
		marginTop: 5,
		marginBottom: 0,
		marginLeft: "auto",
		display: "flex",
		marginRight: "auto",
	},
	previewText: {
		WebkitUserSelect: "none", 
		MozUserSelect: "none",
		msUserSelect: "none",
		userSelect: "none",
	},
	previewTextPremiumBlurred: {
		WebkitUserSelect: "none", 
		MozUserSelect: "none",
		msUserSelect: "none",
		userSelect: "none",
		display: "block",
		filter: "blur(5px)",
	},
	previewTextPremiumHalfBlurred: {
		WebkitUserSelect: "none", 
		MozUserSelect: "none",
		msUserSelect: "none",
		userSelect: "none",
		display: "block",
	},
}));

interface Props {
	sermonTemplate: SermonTemplate;
	disabled: boolean;
	onClose: () => void;
	onUseTemplate: () => void;
}

export function PremiumTemplatePreview(props: Props) {
	const { sermonTemplate, disabled } = props;
	const user = useAuthenticatedUser();
	const isMobile = useIsMobile();
	const classes = useStyles();

	return (
		<Dialog fullWidth maxWidth="md" open={true} onClose={props.onClose} fullScreen={isMobile} disableBackdropClick={disabled} disableEscapeKeyDown={disabled}>
			<DialogTitle>
				<IconButton aria-label="Close" style={{float: "right"}} onClick={props.onClose} disabled={disabled}>
					<CloseIcon />
				</IconButton>
				<Typography variant="h5">{sermonTemplate.name}</Typography>
				<Typography variant="body2">{sermonTemplate.description}</Typography>
				<DialogActions>
					{(user.makerSubscription && !sermonTemplate.isFree) || sermonTemplate.isFree ? (
						<Button
							color="primary"
							className={classes.userTemplateButton}
							size="large"
							onClick={props.onUseTemplate}
							variant="contained"
							disabled={disabled}
						>
							Use Template
						</Button>
					) : (
						<Button
							color="primary"
							className={classes.userTemplateButton}
							size="large"
							onClick={() => upsellToPaid(AddAssetAction.CreateFromPremiumTemplate)}
							variant="contained"
							disabled={disabled}
						>
							Unlock
						</Button>
					)}
				</DialogActions>
			</DialogTitle>
			<Divider />
			<DialogContent>
				{(user.makerSubscription && !sermonTemplate.isFree) || sermonTemplate.isFree ? (
					<span className={classes.previewText} dangerouslySetInnerHTML={{ __html: sermonTemplate.content }} />
				) : (
					<>
						<span className={classes.previewText} dangerouslySetInnerHTML={{ __html: sermonTemplate.content.substring(0, 500) }} />
						<span
							className={classes.previewTextPremiumHalfBlurred}
							dangerouslySetInnerHTML={{ __html: sermonTemplate.content.substring(500, 1000) }}
						/>
						<span
							className={classes.previewTextPremiumBlurred}
							dangerouslySetInnerHTML={{ __html: sermonTemplate.content.substring(1000, 1500) }}
						/>
						<Typography variant="h6" component="h6" align="center">
							Want to see the complete template? Unlock today!
						</Typography>
						<Button
							color="primary"
							className={classes.userTemplateButton}
							size="large"
							onClick={() => upsellToPaid(AddAssetAction.CreateFromPremiumTemplate)}
							variant="contained"
							disabled={disabled}
						>
							Unlock
						</Button>
					</>
				)}
			</DialogContent>
		</Dialog>
	);
}